import { create } from 'zustand'

interface SpotSheetSelectionStore {
  /**
   * スポット一覧でユーザーが選んだコース（キャンペーンスラッグ単位）。
   * 値はシートID文字列、'' は「すべてのコース」を明示的に選んだことを表す。
   * キーがない = まだ選んでいない（初期シートを使う）。
   * メモリ上のみで保持し、リロードで消える（#3334）。
   */
  selectedSheetBySlug: Record<string, string>
  selectSheet: (campaignSlug: string, sheet: string) => void
}

export const useSpotSheetSelectionStore = create<SpotSheetSelectionStore>((set) => ({
  selectedSheetBySlug: {},
  selectSheet: (campaignSlug, sheet) =>
    set((state) => ({ selectedSheetBySlug: { ...state.selectedSheetBySlug, [campaignSlug]: sheet } })),
}))
